import { Injectable } from '@angular/core';
import { Auth, authState, User } from '@angular/fire/auth';
import { from, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(private auth: Auth) { }

  getToken(): Observable<string | null> {
    // `authState` emits only when the user changes (not per request)
    return authState(this.auth).pipe(
      switchMap((user: User | null) => {
        if (!user) return of(null);
        return from(user.getIdToken()); // Converts Promise → Observable
      })
    );
  }

}
